<div class="container">
  <div class="grid grid-cols-12 py-6">
    <div class="col-span-6">
      <h2>Control Center - {{ session.config.title }}</h2>
    </div>

    <div class="col-span-6 flex justify-end sticky top-[72px] z-50 -mt-6 py-6">
      <div class="flex items-center justify-between">
        <button
          class="btn btn-lg shadow"
          [ngClass]="{
            'btn-danger': settingsChanged,
            'btn-primary': !settingsChanged,
          }"
          (click)="saveConfig()">
          <span class="fa fa-save"></span>
          &nbsp; Save Settings
        </button>
      </div>
    </div>

    <div class="col-span-full grid grid-cols-12 gap-4">
      <div class="col-span-6">
        <div class="form-field">
          <label for="title">Session Title:</label>
          <input
            type="text"
            id="title"
            name="session-title"
            [(ngModel)]="session.config.title"
            (change)="settingsChanged = true"
            maxlength="{{ appConfig.inputLengths.SESSION_TITLE }}"
            required
            pInputText />
        </div>
        <div class="form-field">
          <label for="one-liner">Short Description:</label>
          <input
            type="text"
            id="one-liner"
            name="session-oneliner"
            [(ngModel)]="session.config.one_liner"
            (change)="settingsChanged = true"
            maxlength="{{ appConfig.inputLengths.SESSION_ONE_LINER }}"
            pInputText />
        </div>
        <div class="form-field">
          <label for="description">Detailed Description:</label>
          <textarea
            rows="5"
            id="description"
            name="session-description"
            [(ngModel)]="session.config.description"
            (change)="settingsChanged = true"
            maxlength="{{ appConfig.inputLengths.SESSION_DESCRIPTION }}"
            pTextarea></textarea>
        </div>
        <div class="form-field">
          <label for="page-size">Ideas per Page:</label>
          <input
            type="number"
            id="page-size"
            name="page-size"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.page_size"
            min="5"
            pInputText />
        </div>
      </div>

      <div class="col-span-3">
        <h3>Rights Management:</h3>
        <p class="font-bold">Tabs</p>
        <div class="form-field">
          <p-checkbox
            inputId="enable-projects"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.ideas.active" />
          <label for="enable-projects">Enable Projects</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-matrix"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.matrix.active" />
          <label for="enable-matrix">Enable Matrix</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-voting"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.voting.active" />
          <label for="enable-voting">Enable Voting</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-people"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.people.active" />
          <label for="enable-people">Enable People</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-workspace"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.workspace.active" />
          <label for="enable-workspace">Enable Workspace</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-teams-page"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.teams_page.active" />
          <label for="enable-teams-page">Enable Teams Page</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-personal-results"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.personal_results.active" />
          <label for="enable-personal-results">Enable Personal Results</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-pdf-exports"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.pdf_exports.active" />
          <label for="enable-pdf-exports">Enable PDF Exports</label>
        </div>

        <ng-container *ngIf="session.config.matrix.active">
          <p class="font-bold" for>Role-based Rank View</p>
          <div class="form-field">
            <p-checkbox
              inputId="enable-moderators"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.matrix.role_view.moderators" />
            <label for="enable-moderators">
              Show Moderators ({{ moderatorsCount }})
            </label>
          </div>
          <div class="form-field">
            <p-checkbox
              inputId="enable-participants"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.matrix.role_view.participants" />
            <label for="enable-participants">
              Show Participants ({{ participantsCount }})
            </label>
          </div>
          <div class="form-field">
            <p-checkbox
              inputId="enable-external-evaluators"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.matrix.role_view.externals" />
            <label for="enable-external-evaluators">
              Show External Evaluators ({{ externalsCount }})
            </label>
          </div>
        </ng-container>

        <p class="font-bold">Other</p>
        <div class="form-field">
          <p-checkbox
            inputId="enable-rating-own"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config['vote_own_ideas']" />
          <label for="enable-rating-own">Enable Rating own ideas</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-comments"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.comments.active" />
          <label for="enable-comments">Enable Comments</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-benefits-and-challenges"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.benefits_and_challenges" />
          <label for="enable-benefits-and-challenges">
            Enable Benefits &amp; Challenges
          </label>
        </div>
        <ul>
          <li>
            <div
              class="form-field"
              [ngClass]="{ disabled: !session.config.benefits_and_challenges }">
              <p-checkbox
                inputId="enable-solutions"
                [binary]="true"
                (change)="settingsChanged = true"
                [(ngModel)]="session.config.solutions"
                [disabled]="!session.config.benefits_and_challenges" />
              <label for="enable-solutions">Enable Solutions</label>
            </div>
          </li>
        </ul>
        <div class="form-field">
          <p-checkbox
            inputId="enable-expert-finder"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.expert_finder" />
          <label for="enable-expert-finder">Enable Expert Finder</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="enable-suggest-tags"
            [binary]="true"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.suggest_tags" />
          <label for="enable-suggest-tags">
            Enable Tag Suggestion for Ideas
          </label>
        </div>
      </div>

      <div class="col-span-3">
        <h3>Export & Import:</h3>
        <div>
          <button class="btn btn-primary" (click)="openExportWizardModal()">
            <span class="fa fa-file-export"></span>
            Export Ideation Data
          </button>
          <button class="btn btn-primary" (click)="openImportWizardModal()">
            <span class="fa fa-file-import"></span>
            Import Ideation Data
          </button>
        </div>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full">
      <h3 class="mb-6">Edit Teams</h3>

      <p-tabs value="first">
        <p-tablist>
          <p-tab value="first">Overview (All Teams)</p-tab>
          <p-tab
            [value]="i + 1"
            *ngFor="let team of session.config.teams; let i = index">
            {{ team.name }}
          </p-tab>
          <p-tab value="last">Add New Team</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="first">
            <div class="row">
              <div class="col-3 add-participant-step">
                <h4>Participants:</h4>
                <p class="text-sm">
                  Change or Delete Participants
                  <b>
                    (Caution: deleting a participant will cause them to lose all
                    association with ideas etc.)
                  </b>
                </p>
                <ul class="team-list">
                  <ng-container
                    *ngFor="let participant of session.config.participants">
                    <li
                      *ngIf="participant.user"
                      [ngClass]="{
                        active: selectedParticipant === participant,
                      }"
                      class="participant-item"
                      (click)="selectParticipant(participant)">
                      {{ participantName(participant) }}
                      <button
                        type="button"
                        (click)="deleteParticipant(participant)"
                        class="close delete-benefit delete-participant"
                        title="Delete"></button>
                    </li>
                  </ng-container>
                </ul>
              </div>
              <div *ngIf="selectedParticipant" class="col-3">
                <h4>Role:</h4>
                <p class="text-sm">
                  {{ selectedParticipant.user.name }} has the role
                </p>
                <div class="form-field">
                  <p-select
                    name="participant-role-select"
                    [options]="appConfig.rolesSelectOptions"
                    optionLabel="name"
                    optionValue="value"
                    [(ngModel)]="selectedParticipant.role"></p-select>
                </div>
              </div>
              <div *ngIf="selectedParticipant" class="col-3">
                <h4>Team:</h4>
                <p class="text-sm">
                  {{ selectedParticipant.user.name }} is in team
                </p>
                <p-select
                  name="participant-team-select"
                  [options]="session.config.teams"
                  optionLabel="name"
                  optionValue="_id"
                  [(ngModel)]="selectedParticipant.team"></p-select>
              </div>
              <div
                *ngIf="selectedParticipant"
                class="col-3 add-participant-step">
                <h4>Votes for:</h4>
                <p class="text-sm">
                  {{ selectedParticipant.user.name }} votes for the following
                  team(s):
                </p>

                <div
                  class="form-field"
                  *ngFor="let team of session.config.teams; let i = index">
                  <p-checkbox
                    inputId="team-{{ i }}"
                    [binary]="true"
                    [(ngModel)]="team.selected" />
                  <label for="team-{{ i }}">
                    {{ team.name }}
                  </label>
                </div>
                <button class="btn btn-primary" (click)="updateParticipant()">
                  Save Changes to Participant
                </button>
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel
            [value]="i + 1"
            *ngFor="let team of session.config.teams; let i = index">
            <div class="row">
              <div class="col-3 add-participant-step">
                <h4>Participants:</h4>
                <p class="text-sm">
                  Change or Delete Participants
                  <b>
                    (Caution: deleting a participant will cause them to lose all
                    association with ideas etc.)
                  </b>
                </p>
                <ul class="team-list">
                  <ng-container
                    *ngFor="let participant of session.config.participants">
                    <li
                      *ngIf="participant.team === team._id"
                      [ngClass]="{
                        active: selectedParticipant === participant,
                      }"
                      (click)="selectParticipant(participant)">
                      {{ participantName(participant) }}
                      <button
                        type="button"
                        (click)="deleteParticipant(participant)"
                        class="close delete-benefit"
                        title="Close"></button>
                    </li>
                  </ng-container>
                </ul>
              </div>
              <div class="col-3">
                <h4>Role:</h4>
                <p class="text-sm">
                  {{ selectedParticipant.user.name }} has the role
                </p>

                <div class="form-field">
                  <p-select
                    name="participant-team-role-select"
                    [options]="appConfig.rolesSelectOptions"
                    optionLabel="name"
                    optionValue="value"
                    [(ngModel)]="selectedParticipant.role"></p-select>
                </div>
              </div>
              <div class="col-3">
                <h4>Team:</h4>
                <p class="text-sm">
                  {{ selectedParticipant.user.name }} is in team
                </p>

                <p-select
                  name="participant-team-team-select"
                  [options]="session.config.teams"
                  optionLabel="name"
                  optionValue="_id"
                  [(ngModel)]="selectedParticipant.team"></p-select>
              </div>
              <div class="col-3 add-participant-step">
                <h4>Votes for:</h4>
                <p class="text-sm">Votes for the following team(s):</p>
                <div
                  class="form-field"
                  *ngFor="let team of session.config.teams; let i = index">
                  <p-checkbox
                    inputId="team-{{ i }}"
                    [binary]="true"
                    [(ngModel)]="team.selected" />
                  <label for="team-{{ i }}">
                    {{ team.name }}
                  </label>
                </div>
                <button class="btn btn-primary" (click)="updateParticipant()">
                  Save Changes to Participant
                </button>
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel value="last">
            <h4>Add new team</h4>
            <div class="input-group add-participants-input-group">
              <input
                type="text"
                class="form-control team-input"
                [(ngModel)]="team.name"
                maxlength="{{ appConfig.inputLengths.TEAM_NAME }}"
                required />
              <span class="input-group-btn">
                <button
                  class="btn btn-primary"
                  type="submit"
                  (click)="addTeam()">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </button>
              </span>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full">
      <h3>Add New Participant</h3>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-3">
          <div class="form-field">
            <label for="new-participant-email">Email:</label>
            <input
              id="new-participant-email"
              [(ngModel)]="participant.email"
              maxlength="{{ appConfig.inputLengths.EMAIL }}"
              required
              pInputText />
          </div>
        </div>

        <div class="col-span-3">
          <div class="form-field">
            <label for="new-participant-role-select">Role:</label>
            <p-select
              id="new-participant-role-select"
              name="new-participant-role-select"
              [options]="appConfig.rolesSelectOptions"
              optionLabel="name"
              optionValue="value"
              [(ngModel)]="participant.role"></p-select>
          </div>
        </div>
        <div class="col-span-3">
          <div class="form-field">
            <label for="new-participant-team-select">Team:</label>
            <p-select
              id="new-participant-team-select"
              name="new-participant-team-select"
              [options]="session.config.teams"
              optionLabel="name"
              optionValue="_id"
              [(ngModel)]="participant.team"></p-select>
          </div>
        </div>

        <div class="col-span-3">
          <h4>Votes for:</h4>
          <p class="text-sm">Votes for the following team(s):</p>
          <div
            class="form-field"
            *ngFor="let team of session.config.teams; let i = index">
            <p-checkbox
              inputId="new-participant-selected-{{ i }}"
              [binary]="true"
              [(ngModel)]="team.selectedForNewParticipant" />
            <label for="new-participant-selected-{{ i }}">
              {{ team.name }}
            </label>
          </div>
          <button
            class="btn btn-primary"
            type="submit"
            (click)="addParticipant()">
            Save new Participant
          </button>
        </div>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full">
      <h3>Change Session Picture</h3>
      <div class="w-4/12">
        <app-image-upload
          (uploadComplete)="uploadComplete($event)"
          (uploadStart)="uploadStart()"
          [defaultImage]="
            session.config.thumbnail_id || 'image/default_session_thumbnail.png'
          "></app-image-upload>
      </div>
      <div class="form-field">
        <p-checkbox
          inputId="disable-session"
          [binary]="true"
          (change)="settingsChanged = true"
          [(ngModel)]="session.config.restricted" />
        <label for="disable-session">Disable Session</label>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full">
      <h3>Extra Fields on Ideas</h3>
      <p class="text-sm">
        Here you can manage which group of extra-fields each idea in this
        session can have.
      </p>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-4">
          <div class="form-field">
            <p-checkbox
              inputId="extra-idea-for-ws"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.extra_idea_fields.for_ws" />
            <label for="extra-idea-for-ws">Four Ws (Who/What/Why/Where)</label>
          </div>
        </div>

        <div class="col-span-4">
          <div class="form-field">
            <p-checkbox
              inputId="extra-idea-innovation-sweet-spot-medical"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="
                session.config.extra_idea_fields.innovation_sweet_spot_medical
              " />
            <label for="extra-idea-innovation-sweet-spot-medical">
              Innovation Sweetspot (Medical Ideas)
            </label>
          </div>
        </div>

        <div class="col-span-4">
          <div class="form-field">
            <p-checkbox
              inputId="extra-idea-implementation-steps-medical"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="
                session.config.extra_idea_fields.implementation_steps_medical
              " />
            <label for="extra-idea-implementation-steps-medical">
              Implementation Steps (Medical Ideas)
            </label>
          </div>
        </div>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full" *ngIf="session.config.organizer">
      <h3>Session Organizer</h3>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-2">
          <app-image-upload
            (uploadStart)="uploadStart()"
            (uploadComplete)="logoUploadComplete($event)"
            [defaultImage]="
              session.config.organizer.logo_id
            "></app-image-upload>
        </div>
        <div class="col-span-8">
          <div class="form-field">
            <label for="orginizer-name">Organizer:</label>
            <input
              id="orginizer-name"
              type="text"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.organizer.name"
              pInputText />
          </div>
          <div class="form-field">
            <p-checkbox
              inputId="orginizer-enabled"
              [binary]="true"
              (change)="settingsChanged = true"
              [(ngModel)]="session.config.organizer.enabled" />
            <label class="form-label" for="orginizer-enabled">
              Organizer Enabled
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
